import { useContext } from 'react';

import { useAccess } from '../index';
import { SmxPermissionContext } from '../providers/permissionProvider';
import { AttachmentType, PermissionCombinationType } from '../types';

const useAccessForAttachment = (attachment: AttachmentType | null, accessFor: PermissionCombinationType[]) => {
    const { userId } = useContext(SmxPermissionContext);

    const isOwner = attachment?.created_by === userId;

    return useAccess(accessFor, isOwner, false);
};

export default useAccessForAttachment;
